import * as z from 'zod';

export const SupplierFormSchema = z.object({
    name: z
        .string({
            message: 'Name is required!',
        })
        .min(4, {
            message: 'Name at least 4 character!',
        }),
    email: z
        .string({
            message: 'Name is required!',
        })
        .email({
            message: 'Email should be valid!',
        }),
    phone_number: z
        .string({
            message: 'Number is required!',
        })
        .min(11, {
            message: 'Number at least 4 character!',
        }),
    address: z
        .string({
            message: 'Address is required!',
        })
        .min(10, {
            message: 'Address at least 1 character!',
        }),
});

export const CreateSupplierInitialValues = {
    name: '',
    phone_number: '',
    email: '',
    address: '',
};

export type SupplierFormType = z.infer<typeof SupplierFormSchema>;
